import { useTranslations } from "contexts/LocalizationContext";
import { Chakra } from "@airhelp/react-ui-components";
import { RowStyles } from "components/Row";
import SearchBar from "./SearchBar";

const { Box, Flex, Text, Heading } = Chakra;

const Header = () => {
  const translations = useTranslations();

  return (
    <Box pt={{ base: 16, lg: 20 }}>
      <Flex direction="column" pt={28} pb={24} bg="black" alignItems="center" sx={RowStyles["colored-hills"]}>
        <Text textTransform="uppercase" color="primary.500" fontWeight="bold" fontSize="sm" mb={2}>
          {translations("help_center")}
        </Text>
        <Heading color="white" variant="h1" as="h1" textAlign="center">
          {translations("how_can_we_help")}
        </Heading>
        <SearchBar />
      </Flex>
    </Box>
  );
};

export default Header;
